import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaWindowClose, FaFileExcel, FaDownload } from 'react-icons/fa';

// Mostrado após o backend gerar o(s) .xlsx e o browser disparar o(s) download(s).
// O browser NÃO expõe o caminho real do arquivo (restrição da Web API por
// segurança) — mostramos o nome do arquivo + indicação para olhar na pasta
// de Downloads.
//
// Dois modos:
//   - Único: props { url, nomeArquivo } — botão "Baixar novamente" reusa a
//     blob URL ainda viva (revogada quando o modal é fechado).
//   - Múltiplos (ArquivoUnico=false): prop { multiplos: true, quantidade: N }
//     — só mensagem, sem botão de re-download (cada blob URL já foi revogado
//     após o link.click() consecutivo).
const ModalExcelGerado = ({ show, onHide, nomeArquivo, url, multiplos, quantidade }) => {
  const baixarNovamente = () => {
    if (!url || !nomeArquivo) return;
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    link.click();
    link.remove();
  };

  return (
    <Modal show={show} onHide={onHide} size="sm" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>
          <FaFileExcel className="mr-2 text-success" />
          {multiplos ? 'Arquivos gerados' : 'Arquivo gerado'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: 13 }}>
          {multiplos ? (
            <div>
              <div className="mb-2">
                <strong>{quantidade}</strong>
                {quantidade === 1 ? ' arquivo' : ' arquivos'} gerados (1 por empreendimento).
              </div>
              <div className="text-muted" style={{ fontSize: 12 }}>
                Os arquivos foram enviados para a pasta de
                {' '}<strong>Downloads</strong>{' '}
                do seu navegador. Se o navegador pediu permissão para
                downloads múltiplos, clique em <em>Permitir</em> para que
                os próximos sejam baixados.
              </div>
            </div>
          ) : (
            <div>
              <div className="mb-2">
                <strong>Nome do arquivo:</strong>
                <div style={{ wordBreak: 'break-all', color: '#0747a6' }}>
                  {nomeArquivo || '—'}
                </div>
              </div>
              <div className="text-muted" style={{ fontSize: 12 }}>
                O arquivo foi enviado para a pasta de
                {' '}<strong>Downloads</strong>{' '}
                do seu navegador. Caso não localize, use o botão abaixo
                para baixar novamente.
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {!multiplos && (
          <Button
            variant="primary"
            onClick={baixarNovamente}
            disabled={!url}
            className="d-inline-flex align-items-center"
          >
            <FaDownload className="mr-1" /> Baixar novamente
          </Button>
        )}
        <Button
          variant="light"
          onClick={onHide}
          className="d-inline-flex align-items-center"
        >
          <FaWindowClose />
          <span className="ml-2">Fechar</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalExcelGerado;
